import { lazy, Suspense } from 'react';
import { useGameStore } from '../../store/gameStore';
import { selectModeType } from '../../store/selectors';
import { TopBar } from '../hud/TopBar';
import { useExplorationKeyboard } from '../input/useExplorationKeyboard';
import { CombatLayout } from './CombatLayout';
import { ExplorationLayout } from './ExplorationLayout';

const PhaserGame = lazy(() =>
  import('../../game/PhaserGame').then((module) => ({ default: module.PhaserGame })),
);

export function GameShell() {
  const mode = useGameStore(selectModeType);
  const isCombat = mode === 'combat';
  useExplorationKeyboard();

  return (
    <main className={`game-shell mode-${mode}`}>
      <section className="game-viewport" aria-label="Vô Tận Mê Cung">
        <Suspense fallback={<div className="phaser-loading" aria-label="Đang tải cảnh mê cung" />}>
          <PhaserGame />
        </Suspense>
        <div className="viewport-vignette" aria-hidden="true" />
        <div className="viewport-frame" aria-hidden="true" />
        <TopBar />
        {isCombat ? <CombatLayout /> : <ExplorationLayout />}
      </section>
    </main>
  );
}
